export default __webpack_public_path__ + "static/13-new-offer-3bf14ffe96b492a961cea682f472a214.png";